// extracted by mini-css-extract-plugin
module.exports = {"projects":"styles_projects__cZA-_","project":"styles_project__8sJxa","projectFooter":"styles_projectFooter__3kjI7","projectButton":"styles_projectButton__3kEuX"};